import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import LoadingSpinner from '../shared/LoadingSpinner';

/**
 * AuthGuard — The Operator Method access control gate.
 *
 * Simple rule:
 *   loading      → spinner (Firebase auth state resolving)
 *   no UID       → /purgatory (unauthenticated access to a protected page)
 *   UID present  → render children
 *
 * Funnel pages (landing, pricing, micro-assessment, etc.) are public
 * routes — AuthGuard is NOT applied to them.
 * This guard only wraps course/dashboard/protected routes.
 */
export default function AuthGuard({ children }) {
  const { currentUser, loading } = useAuth();
  if (loading) return <LoadingSpinner />;
  if (!currentUser) return <Navigate to="/purgatory" replace />;
  return children;
}
